import { TYPES } from '../../../lib/constants/verticalsData';
import { mapper, nameBuilderMapper } from './transformer';

const getNameByType = (type, urlParams) => {
    if (type === TYPES.NESTED_SUB_CATEGORY) {
        return nameBuilderMapper[type]({
            id: urlParams.id,
            subCategoryId: urlParams.subCategoryId,
        });
    } else {
        return nameBuilderMapper[type]({
            id: urlParams.id,
            subCategoryId: null,
        });
    }
};

export const getItemLink = (type, urlParams, source, locale) =>
    mapper[type] ? mapper[type](urlParams, source, locale) : '';

export const getItemName = (alias, type, urlParams) =>
    alias || (nameBuilderMapper[type] ? getNameByType(type, urlParams) : '');

export const createSourceInfo = ({ videoName, mixpanelPageName, bigQueryPageName }) => ({
    videoName,
    mixpanel: {
        pageName: mixpanelPageName,
    },
    bigQuery: {
        pageName: bigQueryPageName,
    },
});
